module.exports = __webpack_public_path__ + "static/media/ST6-BG2.73bc4fc9.jpg";